<!-- This component should be used in all routes with children but no view or redirect -->
<template>
  <NuxtPage />
</template>
